// @flow

import React, { type Node } from 'react';
import { PixCode } from './pix-code';
import { PixTips } from './pix-tip-box';
import { PixTicket } from './pix-ticket';
import { useReloadAfterPaymentGetItsStatusChanged } from '@tectonics/prs/incoming-payment';
import styled from 'styled-components';

export function PixPendingPage(): Node {
  const refreshInterval = 15000;
  useReloadAfterPaymentGetItsStatusChanged(refreshInterval);
  return (
    <Root data-testid="pix-pending-page">
      <PixTicket />
      <PixCode />
      <PixTips />
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 425px;
  padding-top: 1em;
  > * {
    width: calc(100% - 2em);
    margin: 0.7em auto;
  }
`;
